/**
 * Version Checker - Auto-reload bei neuer Version
 * 
 * Prüft alle 30 Sekunden ob eine neue Version deployed wurde
 * und lädt die Seite automatisch neu (mit Cache-Bypass)
 */

const VERSION_CHECK_INTERVAL = 30000; // 30 Sekunden
// Build version is injected at build time via BUILD_TIMESTAMP_PLACEHOLDER

let checkInterval: NodeJS.Timeout | null = null;
let lastKnownVersion: string | null = null;

export function startVersionCheck() {
  if (import.meta.env.MODE !== 'production') {
    console.info('[Version Check] Disabled in development mode');
    return;
  }

  console.info('[Version Check] 🔍 Started - checking every 30s for updates');

  // Initial check
  checkVersion();

  // Periodischer Check
  checkInterval = setInterval(checkVersion, VERSION_CHECK_INTERVAL);
}

export function stopVersionCheck() {
  if (checkInterval) {
    clearInterval(checkInterval);
    checkInterval = null;
  }
}

async function checkVersion() {
  try {
    // index.html laden (hat Cache-Control: no-store)
    const response = await fetch('/', {
      method: 'HEAD',
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });

    // ETag oder Last-Modified als Version-Identifier
    const etag = response.headers.get('etag');
    const lastModified = response.headers.get('last-modified');
    const version = etag || lastModified;

    if (!version) {
      return; // Keine Version verfügbar
    }

    // Erste Initialisierung
    if (lastKnownVersion === null) {
      lastKnownVersion = version;
      console.info('[Version Check] ✅ Current version:', version);
      return;
    }

    // Versionsprüfung
    if (version !== lastKnownVersion) {
      console.warn('[Version Check] 🚀 NEW VERSION DETECTED!');
      console.warn('[Version Check] Old:', lastKnownVersion);
      console.warn('[Version Check] New:', version);
      console.warn('[Version Check] 🔄 Reloading in 2 seconds...');

      // User benachrichtigen
      showUpdateNotification();

      // Nach 2 Sekunden: Hard Reload (Cache-Bypass)
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  } catch (error) {
    // Fehler stillschweigend ignorieren (Netzwerkprobleme etc.)
    console.debug('[Version Check] Check failed:', error);
  }
}

function showUpdateNotification() {
  const notification = document.createElement('div');
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: linear-gradient(135deg, #009544 0%, #00b855 100%);
    color: white;
    padding: 16px 24px;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0,149,68,0.4);
    z-index: 99999;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 600;
    animation: slideIn 0.3s ease-out;
  `;
  notification.innerHTML = `
    🚀 Neue Version verfügbar!<br>
    <span style="font-size: 12px; opacity: 0.9;">Seite wird neu geladen...</span>
  `;

  // Animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(400px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `;
  document.head.appendChild(style);
  document.body.appendChild(notification);
}
